import { FILTER_SECTION } from "web/react/components/filters-emo/filter-utils";
import environment from "web/script/modules/environment";
import {
    CategoryFilterOption,
    OptionFilterOption,
    UniversalFiltersData,
} from "web/types/universal-filters";
import { UsePopularDesignerPills } from "./types";
import { extractSelectedDesignerFromFilters } from "./utils";

export function getPopularDesignerProfilePills(
    filters: UniversalFiltersData
): Pick<UsePopularDesignerPills, "pills" | "designer"> {
    // Extract the selected type filter (if there is) and the available category filters
    const availableProductTypeFilters = filters.filter_section_list.find(
        (section) => section.id === FILTER_SECTION.categoryFilter
    )?.option_groups[0].options as CategoryFilterOption[] | undefined;
    const selectedProductTypeFilter = availableProductTypeFilters?.find((filter) => filter.checked);

    // In case we have taxonomy filters selected then we are not on designer profile feed
    if (selectedProductTypeFilter) {
        return {
            pills: null,
            designer: null,
        };
    }

    // Get all available category filters
    const availableCategoryFilters = availableProductTypeFilters?.reduce(
        (categories, filter) => [
            ...categories,
            ...((filter.children ?? []) as CategoryFilterOption[]),
        ],
        [] as CategoryFilterOption[]
    );

    // If we don't have popular categories in the environment
    // then we should not show anything
    const feedPopularCategories = environment.get("feedPopularCategories");

    if (!feedPopularCategories?.F?.length && !feedPopularCategories?.M?.length) {
        return {
            pills: null,
            designer: null,
        };
    }

    // Extract designer information to display
    const designer = extractSelectedDesignerFromFilters(filters);

    // If there is no selected gender then we need to show gender pills
    const genderFilters = (
        filters.filter_section_list.find((section) => section.id === FILTER_SECTION.genderFilter)
            ?.option_groups[0].options as OptionFilterOption[] | undefined
    )?.filter((filter) => filter.value !== "all");
    const selectedGenderFilter = genderFilters?.find((filter) => filter.checked);

    // If the section is not in the list then gender is already selected
    if (genderFilters && !selectedGenderFilter) {
        return {
            pills: genderFilters,
            designer,
        };
    }

    const selectedGender = selectedGenderFilter?.value === "Men" ? "M" : "F";

    const pills = availableCategoryFilters?.sort((a, b) => {
        // NB: category filters values are always strings
        const indexOfA = feedPopularCategories[selectedGender].indexOf(a.value as string);
        const indexOfB = feedPopularCategories[selectedGender].indexOf(b.value as string);

        if (indexOfA === -1 && indexOfB === -1) {
            return 0;
        }

        if (indexOfA !== -1 && indexOfB === -1) {
            return -1;
        }

        if (indexOfA === -1 && indexOfB !== -1) {
            return 1;
        }

        return (
            feedPopularCategories[selectedGender].indexOf(a.value as string) -
            feedPopularCategories[selectedGender].indexOf(b.value as string)
        );
    });

    return {
        pills,
        designer,
    };
}
